import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "text-sm text-slate-500 mb-3"
};
const _hoisted_2 = {
  class: "border border-slate-200 rounded p-3 max-h-64 overflow-y-auto"
};
const _hoisted_3 = ["disabled"];
import { ref } from 'vue';
import FolderTreeSelector from './FolderTreeSelector.vue';
export default {
  __name: 'AssetMoveDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '移动'
    },
    itemName: {
      type: String,
      default: ''
    },
    treeData: {
      type: Array,
      default: () => []
    },
    excludeId: {
      type: [Number, String],
      default: null
    }
  },
  emits: ['update:visible', 'confirm'],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const targetFolderId = ref(null);
    const submitting = ref(false);
    function handleConfirm() {
      if (!targetFolderId.value) return;
      emit('confirm', targetFolderId.value);
    }
    return (_ctx, _cache) => {
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        "model-value": __props.visible,
        title: __props.title,
        width: "420px",
        "close-on-click-modal": false,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.$emit('update:visible', $event))
      }, {
        footer: _withCtx(() => [_createElementVNode("button", {
          type: "button",
          class: "btn-secondary",
          onClick: _cache[1] || (_cache[1] = $event => _ctx.$emit('update:visible', false))
        }, "取消"), _createElementVNode("button", {
          type: "button",
          class: "btn-primary",
          disabled: !targetFolderId.value || submitting.value,
          onClick: handleConfirm
        }, _toDisplayString(submitting.value ? '提交中...' : '确定移动'), 9, _hoisted_3)]),
        default: _withCtx(() => [_createElementVNode("p", _hoisted_1, " 将「" + _toDisplayString(__props.itemName) + "」移动到目标文件夹 ", 1), _createElementVNode("div", _hoisted_2, [_createVNode(FolderTreeSelector, {
          nodes: __props.treeData,
          "selected-id": targetFolderId.value,
          "exclude-id": __props.excludeId,
          onSelect: _cache[0] || (_cache[0] = $event => targetFolderId.value = $event)
        }, null, 8, ["nodes", "selected-id", "exclude-id"])])]),
        _: 1
      }, 8, ["model-value", "title"]);
    };
  }
};